import { Badge, Col, Input, Progress, Row } from "antd";
import React, { FC, useEffect, useState } from "react";
import { RightCircleOutlined } from "@ant-design/icons";
import "./subjectsAnalyticsCards.scss";
import ScoreIcon from "../../../../../../../assets/icons/reward.svg";
import AccuracyIcon from "../../../../../../../assets/icons/dart.svg";
import SpeedIcon from "../../../../../../../assets/icons/sketch.svg";
import DurationIcon from "../../../../../../../assets/icons/sand-clock.svg";
import {
  SearchOutlined,
  RightOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import AnalyticsComponent from "../AnalyticsComponent";
import Search from "antd/lib/input/Search";
import { AnalyticsEmptyScreen } from "../EmptyScreen";
import {
  ClassRoomSubjectModel,
  SubjectModel,
} from "../../../../../../../models/CourseModels/SubjectModel/subject.model";
import SubjectService from "../../../../../../../services/CourseServices/SubjectService/subject.service";
interface SubjectsProps {
  onClick: (id: any, name: any) => void;
}
const SubjectsAnalyticsCard: FC<SubjectsProps> = ({ onClick }) => {
  const [subjects, setSubjects] = useState<ClassRoomSubjectModel[]>([]);
  const [selectedSubject, setSelectedSubject] =
    useState<ClassRoomSubjectModel>();
  const [studentSubjectResult, setStudentSubjectResult] = useState<any>({});
  const [showSearch, setSearchVisibility] = useState(false);
  const fetchSubjects = (params: any) => {
    SubjectService.getClassroomSubjectsList(
      "",
      (subjects) => {
        setSubjects(subjects);
        if (subjects?.length) {
          setSelectedSubject(subjects[0]);
        }
      },
      () => {},
      () => {}
    );
  };

  const fetchSubjectAnalytics = (subjectId: any) => {
    // type == "exam"
    //   ? AnalyticsService.fetchExamSubjectAnalytics(
    //       currentCourse?.id,
    //       subjectId,
    //       (result) => {
    //         setStudentSubjectResult(result);
    //       },
    //       () => {}
    //     )
    //   : AnalyticsService.fetchSubjectAnalytics(
    //       currentCourse?.id,
    //       subjectId,
    //       (result) => {
    //         //console.log(result);
    //         setStudentSubjectResult(result);
    //       },
    //       () => {}
    //     );
  };

  useEffect(() => {
    fetchSubjects({});
  }, []);

  return (
    <Row className="list__subjects">
      {subjects.length == 0 ? (
        <AnalyticsEmptyScreen title={"No subjects"} />
      ) : (
        <>
          <Col span={12} style={{ height: "100%" }}>
            <div className="content__left">
              {showSearch ? (
                <div className="content-left__search">
                  <Input
                    className="content-left-search__input"
                    placeholder={"Search"}
                    prefix={<SearchOutlined />}
                    onChange={(e) => {
                      fetchSubjects({ search: e.target.value });
                    }}
                  />
                  <CloseOutlined
                    className="content-left-search__icon"
                    onClick={() => setSearchVisibility(false)}
                  />
                </div>
              ) : (
                <div className="content-left__header">
                  <p>Subjects</p>
                  <div onClick={() => setSearchVisibility(true)}>
                    <SearchOutlined />
                  </div>
                </div>
              )}

              {subjects?.map((value, index) => {
                return (
                  <div
                    className={`analytics-subject__card ${
                      selectedSubject?.id == value.id && "subject-card__active"
                    }`}
                    onClick={() => {
                      setSelectedSubject(value);
                      fetchSubjectAnalytics(value?.id);
                    }}
                  >
                    <p className="subject-card__name">{value?.name}</p>
                    <div className="subjects-details__container">
                      <p>{value?.chapterCount} Chapters</p>
                      <Badge status="default" className="dull-text" />
                      <div className="progress__wrapper">
                        <Progress showInfo={false} />
                        <p>0% Completed</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col span={12} style={{ height: "100%" }}>
            <div className="content__right">
              <div className="content-right__header">
                <p>{selectedSubject?.name}</p>
                <div
                  className="content-right__btn"
                  onClick={() =>
                    onClick(selectedSubject?.id, selectedSubject?.name)
                  }
                >
                  View by chapter{" "}
                  <span>
                    <RightOutlined />
                  </span>
                </div>
              </div>
              <AnalyticsComponent
                showAttempts={false}
                accuracy={studentSubjectResult?.accuracy}
                contentLearnt={0}
                exerciseAttempted={
                  studentSubjectResult?.numberOfExerciseAttempts
                }
                speed={studentSubjectResult?.averageTimePerQuestion}
                score={studentSubjectResult?.score}
                duration={studentSubjectResult?.averageTimePerQuestion}
              />
            </div>
          </Col>
        </>
      )}
    </Row>
  );
};
export default SubjectsAnalyticsCard;
